import { Component, Input, OnInit } from '@angular/core';
import * as dashBoardDetails from '../../../core/models/customer/DashBoardDetails';
import { TranslateService } from '@ngx-translate/core';
import { HomeComponent } from '../home.component';
import { PackageTypes } from '../../../core/enums/package-types';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';

@Component({
  selector: 'main-individual-package',
  templateUrl: './main-individual-package.component.html',
  styleUrls: ['./main-individual-package.component.scss'],
})
export class MainIndividualPackageComponent
  extends BaseComponent
  implements OnInit
{
  @Input() dashBoardPackages: dashBoardDetails.Package[] = [];
  @Input() currentSelectedPackageId: number;
  @Input() showDetailClicked: boolean;
  @Input() currentSelectedPackage: dashBoardDetails.Package;

  constructor(
    translateService: TranslateService,
    public homeComponent: HomeComponent
  ) {
    super(translateService);
  }

  ngOnInit(): void {}
  public get PackageTypeEnum(): typeof PackageTypes {
    return PackageTypes;
  }
}
